import Routes from './Routes.js';

export default Routes;
